import { mapGetters } from "vuex";

import $, { data } from "jquery";
import config from "@/config";
import axios from "axios";
import nl2br from "vue-nl2br";
import SyncLoader from "vue-spinner/src/SyncLoader.vue";

import Loading from "@/components/Loading.vue";
import Modal from "@/components/Modal.vue";
import Cover from "@/components/Cover.vue";
import UploadFile from "@/components/UploadFile.vue";
import TermAndCondition from "@/components/ecommerce/TermAndCondition.vue";
import MerchantDetail from "@/components/ecommerce/MerchantDetail.vue";
import CartItem from "@/components/payment/CartItem.vue";
import BankNumber from "@/components/BankNumber.vue";
import ShippingType from "@/components/ecommerce/ShippingType.vue";
import CartSummary from "@/components/ecommerce/CartSummary.vue";
import { bearhousecalculateshippingprice } from "@/assets/js/BearHouse.js";
import { shippingprice as cdsshippingprice } from "@/assets/js/Cds.js";
import moment from "moment";
// import querystring from "querystring";
import numeral from "numeral";
import { mask } from "vue-the-mask";

import NativeSelect from "@/components/NativeSelect.vue";
import ThaiAddressInput from "@/components/ThaiAddressInput";

import VoucherCodeInput from "@/components/ecommerce/VoucherCodeInput";

const dict = {
  en: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: "Wrong shipping address",
      },
    },
  },
  th: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: "ที่อยู่จัดส่งไม่ถูกต้อง",
      },
    },
  },
  la: {
    custom: {
      shippingAddress: {
        isBearhousezipcode: "ที่อยู่จัดส่งไม่ถูกต้อง",
      },
    },
  },
};

export default {
  directives: { themask: mask },
  data() {
    return {
      allproducts: [],
      monobobanklist: [
        { text: "ธนาคารกรุงเทพ", value: "กรุงเทพ" },
        { text: "ธนาคารที.เอ็ม.บี (ทหารไทย)", value: "ที.เอ็ม.บี (ทหารไทย)" },
        { text: "ธนาคารไทยพาณิชย์", value: "ไทยพาณิชย์" },
        { text: "ธนาคารกสิกรไทย", value: "กสิกรไทย" },
        { text: "ธนาคารยูโอบี", value: "ยูโอบี" },
      ],
      facebookname: "",
      encodedfacebookname: "",
      amount: "",
      creditcard: {
        name: "",
        number: "",
        validate: "",
        expiremonth: "",
        expireyear: "",
        cvv: "",
      },
      orderid: "",
      gbprime: {
        url: null,
        token: null,
        refno: null,
        backgroundUrl: null,
        amount: null,
      },
      timestamp: moment().format("x"),
      app: "facebook",
      pageid: null,
      userid: null,
      paiddate: null,
      paidtime: null,
      products: {},
      remark: "",
      transferType: "",

      additionalproduct_charge: 0,
      ems_charge: 0,
      normal_charge: 0,
      kerry_charge: 0,
      total: 0,
      totalincludediscount: 0,
      discount: 0,

      shippingType: undefined,

      loading: false,
      pageLoading: true,

      isCompleted: false,
      isEmptyShoppingCart: false,

      shippingAddress: null,
      showAlert: false,
      showProduct: false,
      shippinglist: undefined,
      showQrCode: false,
      qrimage: "",
      intervalQrCode: null,
      timer: 300,
      isRequest: true,
      referenceNo: "",

      config: {
        color: config.color,
      },

      sessiontoken: null,
      banktransferinfo: null,
      banktransferinfo_photo: null,
      paymentSlipImage: null,

      showTerm: false,
      customerName: null,
      customerPhone: null,
      loadingQrcode: false,
      isCartOutOfStock: false,
      bankname: null,
      isPaypal: false,
      paypal_merchantid: null,

      shippingAddress2: {
        address: "",
        zipcode: "",
        province: "",
        district: "",
        sub_district: "",
      },
      useOldAddress: [
        "101900391252252", //Russian
        "485851741439218", //ยงยู่กี่
        "1937813489833600", //shouwa88
      ],
      allowtransfer: false,
      allowcreditcard: false,

      loadingVoucher: true,
      voucher: null,
      voucherCode: null,
      hasVoucher: false,
      gbpath: "https://api.gbprimepay.com",
      gbcharge: null,
      gbpublickey: "",
      serverUrl: config.getConfig("serverUrl"),
      hasShippingNow: false,
      hasOtherProduct: false,
    };
  },
  mounted: async function () {
    let vm = this;

    vm.$validator.localize(dict);
    vm.$validator.localize(this.currentLang);

    vm.loading = true;

    if (vm.$route.query.userid) {
      vm.userid = vm.$route.query.userid;
    }

    if (vm.$route.query.pkey) {
      vm.omise_key = vm.$route.query.pkey;
    }

    if (vm.$route.query.sessiontoken) {
      vm.sessiontoken = vm.$route.query.sessiontoken;
    }

    vm.pageLoading = true;

    vm.pageid = vm.pageProfile.pageid;
    vm.allowcreditcard = vm.pageProfile.allowcreditcard == "true" ? true : false;

    document.title = vm.pageProfile.pagename;
    vm.$store.dispatch("updateShopColor", vm.pageProfile.shopcolor);
    vm.pageLoading = false;
    vm.gbpublickey = vm.pageProfile.gbprime_publickey;

    vm.hasVoucher = vm.pageProfile.ispromocode;

    // await vm.checkpageusepromocode();

    if (vm.$route.query.app) {
      vm.app = vm.$route.query.app;
    }

    if (vm.userid) {
      try {
        let firstletterofuserid = vm.userid.charAt(0);
        if (firstletterofuserid && firstletterofuserid.toLowerCase() == "u") {
          vm.app = "line";
        }
      } catch (error) {
        // eslint-disable-next-line
        console.error(error);
      }

      // var response_lang = await vm.$store.dispatch("getUserShopLang", {
      //   pageid: vm.pageProfile.pageid,
      //   userid: vm.userid,
      // });
      // vm.facebookname = response_lang.facebookname;
      // if (response_lang) {
      //   vm.$store.dispatch("setLang", response_lang.usershoplang);
      // }
      vm.facebookname = vm.pageProfile.pagename;
      vm.$store.dispatch("setLang", vm.pageProfile.shoplang);

      var userdata = await vm.getUserDetail();
      vm.customerName = userdata.name;
      vm.customerPhone = userdata.phone;
      if (vm.pageProfile.type == "bec") {
        vm.inputBec.email = userdata.email ? userdata.email : "";
      }
      // vm.shippingAddress = userdata.address;
      var shippingaddress = userdata.address ? userdata.address.split(" , ") : [];
      if (shippingaddress.length >= 5 && !vm.useOldAddress.includes(vm.pageProfile.pageid)) {
        vm.shippingAddress2.zipcode = shippingaddress.pop();
        vm.shippingAddress2.province = vm.replaceAddress(shippingaddress.pop());
        vm.shippingAddress2.district = vm.replaceAddress(shippingaddress.pop());
        vm.shippingAddress2.sub_district = vm.replaceAddress(shippingaddress.pop());
        vm.shippingAddress = shippingaddress.join(" ");
      } else {
        vm.shippingAddress = userdata.address;
      }
      vm.remark =
        vm.pageProfile.type == "monobo" && userdata.remark && userdata.remark != null
          ? userdata.remark.split(";;")[0]
          : userdata.remark;
    }
    if (vm.pageProfile.wholesale_status === true) {
      // vm.$store.dispatch("getWholeSaleStatus", vm.pageProfile.pageid).then(function() {
      vm.$store.dispatch("getWholeSale", vm.pageProfile.pageid);
      // });
    }
    if (this.pageProfile.theme === 'runkan') {

      await vm.getRunkanProfileData()
    }
    // await vm.getProducts();
    vm.loadingVoucher = true;
    await vm.getUserCart();
    await vm.$nextTick();
    vm.loadingVoucher = false;
    // await vm.getTransferDetail();
    if (this.pageProfile.paypal_merchantid) {
      vm.isPaypal = true;
    }

    if (this.isPaypal) {
      // vm.renderPaypalBtn();
    }

    var isCartOutOfStock = this.cart.filter(function (el) {
      if (parseInt(el.remainingquantity) < parseInt(el.quantity)) {
        return true;
      } else {
        return false;
      }
    });

    this.isCartOutOfStock = isCartOutOfStock.length > 0;

    this.setTransferDefault();
    this.setShippingDefault();
    if (this.isCartOutOfStock) {
      await this.$swal({
        title: this.$t("Not enough products in stock"),
        text: this.$t("Please try to order again or contact Admin"),
        type: "warning",
        confirmButtonText: this.$t("Confirm"),
        cancelButtonText: this.$t("Cancel"),
        reverseButtons: true,
      });
      if (this.$liff.isInClient()) {
        // eslint-disable-next-line no-undef
        await this.$liff.sendMessages([
          {
            type: "text",
            text:
              this.$t("Not enough products in stock") +
              ", " +
              this.$t("Please try to order again or contact Admin"),
          },
        ]);
        // eslint-disable-next-line no-undef
        // await this.$liff.closeWindow();
      }
    }
    if (
      ["112085313900804", "10242104823979", "105928254552462"].includes(this.pageProfile.pageid)
    ) {
      await vm.testCentral2c2p();
    }
    await this.callafter();

    vm.loading = false;
  },
  components: {
    SyncLoader,
    Loading,
    Modal,
    Cover,
    MerchantDetail,
    nl2br,
    UploadFile,
    TermAndCondition,
    CartItem,
    BankNumber,
    ShippingType,
    CartSummary,
    NativeSelect,
    ThaiAddressInput,
    VoucherCodeInput,
  },
  computed: {
    payment_option() {
      if (["104716585038207", "362065616073"].includes(this.pageProfile.pageid)) return "CC";
      return "ALL";
    },
    showOnlyQRpage() {
      return ["141179435910975"].includes(this.pageid);
    },
    ...mapGetters({
      cart: "getCart",
      currentLang: "currentLang",
      loadingPageProfile: "getLoadingPageProfile",
      pageProfile: "getPageProfile",
      theme: "getTheme",
    }),
    hasPaymentMethodMoreThanOne() {
      return (
        this.pageProfile.fbpay_status ||
        this.pageProfile.gbprime_status ||
        (this.shippinglist &&
          this.shippinglist.hasOwnProperty("cod_charge") &&
          this.shippinglist["cod_charge"][1]) ||
        this.pageProfile.paypal_merchantid
      );
    },
    paymentList() {
      var payments = [];

      if (this.allowtransfer) {
        payments.push("transfer");
      }

      if (this.pageProfile.gbprime_status) {
        payments.push("gbprime");
      }

      if (this.$store.state.page2c2p.includes(this.pageid) || this.pageProfile.type == "bec") {
        payments.push("2c2p");
      }

      if (
        this.$store.state.gbpayment.includes(this.pageid) ||
        this.pageProfile.gbprimecredit_status
      )
        payments.push("creditgbprime");

      if (this.pageProfile.fbpay_status && !this.$store.state.cds.includes(this.pageid)) {
        payments.push("fbpay");
      }
      if (this.allowcreditcard && this.pageProfile.paypal_merchantid) {
        payments.push("paypal");
      }

      if (
        this.shippinglist &&
        this.shippinglist.hasOwnProperty("cod_charge") &&
        this.shippinglist["cod_charge"][1]
      ) {
        payments.push("cod");
      }

      return payments;
    },
    bearhouseshippingprice() {
      var zipcode = this.shippingAddress2.zipcode;
      return bearhousecalculateshippingprice(zipcode, this.cart.length);
    },
    cdsshippingprice() {
      var zipcode = this.shippingAddress2.zipcode;
      if (["103551424764072", "392612533487"].includes(this.pageProfile.pageid)) {
        //robinsontest //rbs
        if (this.total >= 599) return 0;
        else return 50;
      } else if (["122424499005", "134297248716"].includes(this.pageProfile.pageid)) {
        return 0;
      } else {
        return cdsshippingprice(zipcode, this.totalincludediscount);
      }
    },
    isBearhouse() {
      return this.pageProfile && this.$store.state.bearhouse.includes(this.pageProfile.pageid);
    },
    isCDS() {
      return this.pageProfile && this.$store.state.cds.includes(this.pageProfile.pageid);
    },
    isOoca() {
      return (
        this.pageProfile && ["100935418246290", "142088386194745"].includes(this.pageProfile.pageid)
      );
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == "smoothe";
    },
    pagename: function () {
      return this.$route.query.pageid
        ? this.$route.query.pageid
        : this.$route.params.id
          ? this.$route.params.id
          : undefined;
    },
    extractShippingZipcode() {
      var zipcode = "";
      if (this.shippingAddress && this.shippingAddress.match(/([A-z]|[ก-๛]|\s)[1-9][0-9]{4}/g)) {
        zipcode = this.shippingAddress.match(/([A-z]|[ก-๛]|\s)[1-9][0-9]{4}/g)[0].trim();
        zipcode = zipcode.match(/([1-9][0-9]{4})|^([1-9][0-9]{4})/)[0];
      }
      return zipcode;
    },
    totalPrice: function () {
      var total = this.totalincludediscount;
      var shippingPrice = 0;

      if (this.isBearhouse) {
        shippingPrice = this.bearhouseshippingprice;
      } else if (this.isCDS) {
        shippingPrice = this.cdsshippingprice;
      } else if (this.shippingType) {
        if (this.isSmoothE) {
          var smootheShippingPrice = total >= 500 ? 0 : this.shippingType.value;
          shippingPrice = smootheShippingPrice;
        }
        shippingPrice = this.shippingType.value;
      } else {
        //
      }

      if (shippingPrice && this.voucher) {
        if (this.voucher.freeship) {
          shippingPrice = 0;
        } else if (shippingPrice > this.voucher.discountship) {
          shippingPrice = shippingPrice - this.voucher.discountship;
        } else {
          shippingPrice = 0;
        }
      }

      return total + shippingPrice;
    },
  },
  methods: {
    getRunkanProfileData() {
      var data = {
        pageid: this.pageid,
        userid: this.userid,
      };
      return new Promise((resolve) => {
        axios
          .get(config.getConfig("serverUrl") + "runkanmember", {
            params: data,
            headers: { AUTHORIZATION: "Bearer xxxx xxx" },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200 && response.data.data) {
              // this. = response.data.data[0];
              this.customerPhone = response.data.data[0].phoneno;
              resolve();
            } else {
              await this.$swal.fire({
                text: response.data.reason
              })
              this.$liff.closeWindow()
            }
          });
      });
    },
    changeHasShippingNow(hasShippingNow) {

      if (!hasShippingNow) {
        var shippinglist = Object.keys(this.shippinglist).map((key) => ({
          name: key,
          value: this.shippinglist[key],
        }));

        var shipping = shippinglist.filter((el) => {
          return !["additionalproduct_charge", "cod_charge"].includes(el.name) && el.value[1];
        });


        if (shipping && shipping.length > 0) {
          var val = shipping.find((el) => {
            return el.name == "other_charge";
          });

          if (val) {
            this.shippingType = {
              type: val.name,
              value: val.value[0],
            };
          }
        }
      }
    },
    async checkpageusepromocode() {
      var response = await axios.get(config.getConfig("serverUrl") + `checkpageusepromocode`, {
        params: {
          pageid: this.pageProfile.pageid,
        },
      });

      if (response.status == 200 && response.data.data) this.hasVoucher = true;
    },
    async callafter() { },
    onUpdateTotal: async function (payload) {
      this.voucher = payload;
      this.loadingVoucher = true;
      await this.getUserCart();
      this.loadingVoucher = false;
    },
    replaceAddress(val) {
      if (!val || val.trim() == "") return "";
      return val
        .trim()
        .replace("เขต", "")
        .replace("แขวง", "")
        .replace("อำเภอ", "")
        .replace("ตำบล", "")
        .replace("จังหวัด", "");
    },
    setShippingDefault(type) {
      if (type == "cod_charge" && this.shippinglist["cod_charge"]) {
        this.shippingType = {
          type: "cod_charge",
          value: this.shippinglist["cod_charge"][0],
        };
        this.transferType = "cod_charge";
      } else {
        var shippinglist = Object.keys(this.shippinglist).map((key) => ({
          name: key,
          value: this.shippinglist[key],
        }));

        var shipping = shippinglist.filter((el) => {
          return !["additionalproduct_charge", "cod_charge"].includes(el.name) && el.value[1];
        });

        if (shipping && shipping.length > 0) {
          if (this.shippingType && this.shippingType.type != "cod_charge") {
            //
          } else {
            if (this.pageProfile.type == "nvbb") {
              var val = shipping.find((el) => {
                return el.name == "other_charge";
              });
              if (val) {
                this.shippingType = {
                  type: val.name,
                  value: val.value[0],
                };
              }
            } else {
              this.shippingType = {
                type: shipping[0].name,
                value: shipping[0].value[0],
              };
            }
          }
        }
      }
    },
    setTransferDefault() {
      if (this.paymentList.length > 0) {
        if (this.paymentList[0] == "gbprime") {
          this.transferType = "qrcode";
        } else if (this.paymentList[0] == "cod") {
          this.shippingType = {
            type: "cod_charge",
            value: this.shippinglist["cod_charge"][0],
          };
          this.transferType = "cod_charge";
        } else {
          if (this.transferType && this.transferType != "cod_charge") {
            //
          } else {
            var hasTransfer = this.paymentList.find((el) => {
              return el == "transfer";
            });

            if (hasTransfer) this.transferType = "transfer";
            else this.transferType = this.paymentList.filter((el) => el != "cod_charge")[0];
          }
        }
      } else {
        this.transferType = "transfer";
      }
    },
    onSelectAddress(address) {
      this.shippingAddress2.sub_district = address.district;
      this.shippingAddress2.district = address.amphoe;
      this.shippingAddress2.province = address.province;
      this.shippingAddress2.zipcode = address.zipcode;
    },
    testCentral2c2p() {
      return new Promise((resolve) => {
        let externalScript = document.createElement("script");
        externalScript.setAttribute(
          "src",
          `https://demo2.2c2p.com/2C2PFrontEnd/SecurePayment/api/my2c2p.1.6.9.min.js`
        );
        externalScript.async = true;
        externalScript.defer = true;
        externalScript.onload = () => {
          resolve();
        };
        document.head.appendChild(externalScript);
      });
    },
    changeShippingType(payload) {
      if (payload.type != "cod_charge") {
        this.setTransferDefault();
      } else {
        this.setShippingDefault("cod_charge");
      }
    },
    onChangeExpireDate(e) {
      var exp = e.split("/");

      if (exp && exp.length) {
        if (exp[0]) {
          this.creditcard.expiremonth = exp[0];
        } else {
          this.creditcard.expiremonth = exp[0];
        }
        if (exp[1]) {
          this.creditcard.expireyear =
            new Date()
              .getFullYear()
              .toString()
              .substr(0, 2) + exp[1];
        } else this.creditcard.expireyear = "";
      }
    },
    submit2c2p(e) {
      // e.preventDefault();
      let vm = this;
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput();
          return false;
        }
        // eslint-disable-next-line no-undef
        My2c2p.submitForm("2c2p-payment-form", function (errCode, errDesc) {
          if (errCode != 0) {
            vm.$swal({
              type: "error",
              text: errDesc + " (" + errCode + ")",
            });
          } else {
            // vm.handleSubmit();
            // vm.$refs.form2c2p.form.submit();
          }
        });
      });
    },
    async checkOrderStatus() {
      //   var total = numeral(0.01).format("0.00");
      var total = numeral(this.totalPrice).format("0.00");
      var response = await axios.get(
        config.getConfig("serverUrl") +
        `gbcompletedwithrefnoverify?referenceNo=${this.referenceNo}&pageid=${this.pageid
        }&userid=${this.userid}&amount=${total}`
      );
      return response;
    },
    getByte(str) {
      var enc = new TextEncoder();
      return enc.encode(str);
    },
    requestQrCode2(photo) {
      // var vm = this;
      return new Promise((resolve, reject) => {
        if (photo) {
          // var photobyte = vm.getByte(photo);
          resolve(new Uint8Array(photo));
        } else {
          reject();
        }
      });
    },

    async submitOrder() {
      if (this.isEmptyShoppingCart) {
        return false;
      }
      var data = this.formatOrderRequest();

      data.note = this.paymentSlipImage;

      if (this.transferType == "qrcode") {
        data.paiddate = moment();
        data.transactionid = this.referenceNo;
      } else {
        data.paiddate = moment(`${this.paiddate} ${this.paidtime}`);
      }

      try {
        var response = await this.banktransfernotify(data);

        // JSON responses are automatically parsed.
        response = response.data;
        if (response.responsecode == 200) {
          this.isCompleted = true;
          await this.$store.dispatch("deleteAllItemsInCart");
          // eslint-disable-next-line
          if (this.$liff.isInClient()) {
            var prefix_message =
              this.pageProfile.pageid == "102459484852582"
                ? "ดำเนินการสั่งซื้อเรียบร้อย Cart No. "
                : "Order: ";
            // eslint-disable-next-line no-undef
            await this.$liff.sendMessages([
              {
                type: "text",
                text: prefix_message + response.orderid,
              },
            ]);
            // eslint-disable-next-line no-undef
            await this.$liff.closeWindow();
          } else {
            // eslint-disable-next-line no-undef
            MessengerExtensions.requestCloseBrowser(
              function success() { },
              function error() {
                window.close();
              }
            );
          }
        } else if (response.responsecode == 201) {
          this.isCompleted = true;
          await this.$store.dispatch("deleteAllItemsInCart");
          let url = "/ecommerce/" + this.pagename;
          if (this.userid && this.userid != null && this.userid != "") {
            url += "?userid=" + this.userid;
          }
          this.$router.push({ path: url });
        } else {
          await this.$swal({
            title: this.$t("Error"),
            text: this.$t("Something went wrong. Please try it again."),
            type: "error",
            confirmButtonText: this.$t("Confirm"),
            cancelButtonText: this.$t("Cancel"),
            reverseButtons: true,
          });
        }
      } catch (error) {
        this.loading = false;
        await this.$swal({
          title: this.$t("Error"),
          text: this.$t("Something went wrong. Please try it again."),
          type: "error",
          confirmButtonText: this.$t("Confirm"),
          cancelButtonText: this.$t("Cancel"),
          reverseButtons: true,
        });
      }
    },
    async closeQrCode() {
      this.showQrCode = false;
    },
    async getQrCode2() {
      var result = await this.$validator.validate();
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput();
        throw 400;
      }

      try {
        this.loadingQrcode = true;
        let photo = await this.gbcreaterefnofromcart();
        var response = await this.requestQrCode2(photo);
        var binary = response.reduce((data, b) => (data += String.fromCharCode(b)), "");
        this.qrimage = "data:image/jpeg;base64," + btoa(binary);
      } catch (error) {
        throw error;
      }
      this.loadingQrcode = false;
    },
    async gbcreaterefnofromcart() {
      try {
        var data = this.formatOrderRequest();

        let detail = [];
        this.cart.map((el) => {
          detail.push(`${el.name}${el.option ? ` (${el.option})` : ""} x ${el.quantity}`);
        });

        let stringdetail = detail.join(",");
        if (stringdetail.length < 250) {
          stringdetail.slice(0, 250);
        }

        data.detail = stringdetail;
        data.note = this.paymentSlipImage;
        if (this.$route.query.from) {
          data.from = this.$route.query.from;
        } else {
          try {
            var device = this.$liff.getOS();
            var version = this.$liff.getVersion();
            await this.$liff.ready;

            if (this.userid.indexOf("__") != -1 && device && version && !this.$liff.isInClient()) {
              data.from = "livechat";
            }
          } catch (error) {
            // eslint-disable-next-line
            console.log(error);
          }
        }

        let response = await axios.post(
          config.getConfig("serverUrl") + "gbcreaterefnofromcart",
          data,
          {
            params: {},
            headers: { AUTHORIZATION: "Bearer xxx xxx" },
            responseType: "arraybuffer",
          }
        );
        if (response.status == 200) {
          // console.log(response.data);
          return response.data;
        } else {
          throw 400;
        }
      } catch (error) {
        throw error;
      }
    },
    getUserDetail: function () {
      let vm = this;
      return new Promise((resolve, reject) => {
        axios
          .get(
            config.getConfig("serverUrl") +
            "lastorderaddress?pageid=" +
            vm.pageid +
            "&userid=" +
            vm.userid
          )
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (response.data) {
                resolve(response.data);
              } else {
                reject();
              }
            } else {
              reject();
              // console.log(response);
            }
          });
      });
    },
    openModal: function () {
      this.showTerm = true;
      let vm = this;
      window.location.hash = "#modal-open";
      window.onpopstate = function () {
        if (location.hash == "#modal-open") {
          //   console.log("test");
        } else {
          vm.showTerm = false;
        }
      };
    },
    close: function () {
      var vm = this;

      if (window.history.length == 0) {
        vm.showTerm = false;
      } else {
        window.history.back();
      }
    },
    getTransferDetail: async function () {
      let vm = this;
      var response = await axios.get(
        config.getConfig("serverUrl") + "banktransferinfo?pageid=" + vm.pageid
      );
      // JSON responses are automatically parsed.
      response = response.data;
      if (response.responsecode == 200) {
        vm.allowtransfer = response.allowtransfer == true || response.allowtransfer == "true";
        vm.banktransferinfo = response.banktransferinfo;
        vm.banktransferinfo_photo = response.banktransferinfo_photo;
      } else {
        //
      }

      return Promise.resolve();
    },
    async gbcreditSubmit() {
      var result = await this.$validator.validate();
      if (!result) {
        // do stuff if not valid.
        this.goToErrorInput();
        return false;
      }
      if (this.isEmptyShoppingCart) {
        return false;
      }
      this.loading = true;
      var response = await this.getGBCreditToken();

      if (response.status == 200 && response.data.resultCode == "00") {
        var data = this.formatOrderRequest();
        data.creditcardtoken = response.data.card.token;
        var order_response = await this.banktransfernotify(data);
        if (order_response.status == 200 && order_response.data.responsecode == 200) {
          this.gbcharge = {
            gbpReferenceNo: order_response.data.transactionid,
          };
          await this.$nextTick();
          this.$refs.gbchargeform.submit();
        }
      }

      this.loading = false;
    },
    async getGBCreditCharge({ token, referenceNo }) {
      var data = this.formatOrderRequest();

      let detail = [];
      var secretKey = "eoRYCmihqMtK7sHbikeitoRHigvY3xcb";
      this.cart.map((el) => {
        detail.push(`${el.name}${el.option ? ` (${el.option})` : ""} x ${el.quantity}`);
      });

      let stringdetail = detail.join(",");
      if (stringdetail.length < 250) {
        stringdetail.slice(0, 250);
      }

      data.detail = stringdetail;
      data.note = this.paymentSlipImage;
      data.referenceNo = referenceNo;
      data.card = {
        token: token,
      };
      data.otp = "Y";
      data.responseUrl = "https://payment.zwiz.ai/gbprime";
      var serverUrl = config.getConfig("serverUrl")
      data.backgroundUrl = serverUrl + "gbprimebackendresult";
      data.amount = parseInt(data.amount) / 100;
      if (this.$route.query.from) {
        data.from = this.$route.query.from;
      } else {
        try {
          var device = this.$liff.getOS();
          var version = this.$liff.getVersion();
          await this.$liff.ready;

          if (this.userid.indexOf("__") != -1 && device && version && !this.$liff.isInClient()) {
            data.from = "livechat";
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
        }
      }

      var url = `${this.gbpath}/v1/tokens/charge`;
      // delete axios.defaults.headers.common["Authorization"];
      axios.defaults.headers.common = {
        AUTHORIZATION: "Basic " + btoa(secretKey + ":"),
      };
      return await axios.post(url, data, {});
    },
    async getGBCreditToken() {
      var dataReq = {
        rememberCard: false,
        card: {
          name: this.creditcard.name,
          number: this.creditcard.number,
          expirationMonth: this.creditcard.expiremonth,
          expirationYear: this.creditcard.expireyear.substr(-2),
          securityCode: this.creditcard.cvv,
        },
      };
      if (this.$route.query.from) {
        dataReq.from = this.$route.query.from;
      } else {
        try {
          var device = this.$liff.getOS();
          var version = this.$liff.getVersion();
          await this.$liff.ready;

          if (this.userid.indexOf("__") != -1 && device && version && !this.$liff.isInClient()) {
            data.from = "livechat";
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
        }
      }

      var url = `${this.gbpath}/v1/tokens`;
      // delete axios.defaults.headers.common["Authorization"];
      axios.defaults.headers.common = {
        AUTHORIZATION: "Basic " + btoa(this.gbpublickey + ":"),
      };
      return await axios.post(url, dataReq, {});
    },
    async qrHandleSubmit() {
      try {
        await this.getQrCode2();
        this.showQrCode = true;
      } catch (error) {
        // console.log(error);
      }
    },
    handleSubmit: function () {
      let vm = this;
      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput();
          return false;
        }
        if (vm.isEmptyShoppingCart) {
          return false;
        }
        vm.loading = true;

        var data = vm.formatOrderRequest();

        this.banktransfernotify(data)
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              if (
                data.payment == "2c2p" &&
                (vm.isCDS || vm.$store.state.page2c2p.includes(vm.pageProfile.pageid))
              ) {
                vm.orderid = response.orderid;
                vm.amount = data.total;
                vm.$nextTick(() => {
                  vm.submit2c2p();
                });
              } else {
                vm.isCompleted = true;
                vm.$store.dispatch("deleteAllItemsInCart");
                // eslint-disable-next-line
                if (vm.$liff.isInClient()) {
                  var prefix_message =
                    vm.pageProfile.pageid == "102459484852582"
                      ? "ดำเนินการสั่งซื้อเรียบร้อย Cart No. "
                      : "Order: ";
                  // eslint-disable-next-line no-undef
                  vm.$liff
                    .sendMessages([
                      {
                        type: "text",
                        text: prefix_message + response.orderid,
                      },
                    ])
                    .then(() => {
                      // eslint-disable-next-line no-undef
                      vm.$liff.closeWindow();

                    });
                } else {
                  // eslint-disable-next-line no-undef
                  MessengerExtensions.requestCloseBrowser(
                    function success() { },
                    function error() {
                      window.close();
                    }
                  );
                }
              }
            } else if (response.responsecode == 400) {
              vm.$swal({
                title: vm.$t("Error"),
                text: vm.$t(response.reason),
                type: "error",
                confirmButtonText: vm.$t("Confirm"),
                cancelButtonText: vm.$t("Cancel"),
                reverseButtons: true,
              });
            } else if (response.responsecode == 201) {
              vm.isCompleted = true;
              vm.$store.dispatch("deleteAllItemsInCart");
              let url = "/ecommerce/" + vm.pagename;
              if (vm.userid && vm.userid != null && vm.userid != "") {
                url += "?userid=" + vm.userid;
              }
              vm.$router.push({ path: url });
            } else {
              vm.$swal({
                title: vm.$t("Error"),
                text: vm.$t("Something went wrong. Please try it again.."),
                type: "error",
                confirmButtonText: vm.$t("Confirm"),
                cancelButtonText: vm.$t("Cancel"),
                reverseButtons: true,
              });
            }
            vm.loading = false;
          })
          .catch((err) => {
            console.log(err);
            vm.loading = false;
            vm.$swal({
              title: vm.$t("Error"),
              text: vm.$t("Something went wrong. Please try it again."),
              type: "error",
              confirmButtonText: vm.$t("Confirm"),
              cancelButtonText: vm.$t("Cancel"),
              reverseButtons: true,
            });
          });
      });
    },
    async banktransfernotify(data) {
      if (this.$route.query.from) {
        data.from = this.$route.query.from;
      } else {
        try {
          var device = this.$liff.getOS();
          var version = this.$liff.getVersion();
          await this.$liff.ready;

          if (this.userid.indexOf("__") != -1 && device && version && !this.$liff.isInClient()) {
            data.from = "livechat";
          }
        } catch (error) {
          // eslint-disable-next-line
          console.log(error);
        }
      }
      let url = config.getConfig("serverUrl") + "banktransfernotify";

      if (this.sessiontoken != null || this.sessiontoken != "") {
        url += "?sessiontoken=" + this.sessiontoken;
      }
      return await axios.post(url, data);
    },
    formatOrderRequest() {
      var total = this.total;
      var shippingCharge = 0;
      if (this.shippingType) {
        shippingCharge = this.shippingType.value;
        total += shippingCharge;
        // if (this.voucher) {
        //   if (this.voucher.freeship) {
        //     shippingCharge = 0;
        //   } else if (this.voucher.discountship > 0) {
        //     if (this.voucher.discountship >= shippingCharge) {
        //       shippingCharge = 0;
        //     } else {
        //       shippingCharge = shippingCharge - this.voucher.discountship;
        //     }
        //   }
        // }
      }
      var payment;
      if (this.transferType) {
        payment = this.transferType;
      } else {
        payment = null;
      }
      var note = this.paymentSlipImage;

      this.shippingAddress;

      var combine_address = "";
      var shipping_address = null;
      combine_address = this.shippingAddress.replace(/,/g, "");
      if (
        !this.useOldAddress.includes(this.pageProfile.pageid) &&
        this.shippingAddress2.sub_district &&
        this.shippingAddress2.district &&
        this.shippingAddress2.province &&
        this.shippingAddress2.zipcode
      ) {
        var inBangkok = this.shippingAddress2.province == "กรุงเทพมหานคร";
        combine_address =
          combine_address +
          " , " +
          [
            (inBangkok ? "แขวง" : "ตำบล") + this.shippingAddress2.sub_district.replace(/,/g, ""),
            (inBangkok ? "เขต" : "อำเภอ") + this.shippingAddress2.district.replace(/,/g, ""),
            "จังหวัด" + this.shippingAddress2.province.replace(/,/g, ""),
            this.shippingAddress2.zipcode.replace(/,/g, ""),
          ].join(" , ");

        shipping_address = {
          name: this.customerName,
          province: this.shippingAddress2.province.replace(/,/g, ""),
          zipcode: this.shippingAddress2.zipcode.replace(/,/g, ""),
          district: this.shippingAddress2.district.replace(/,/g, ""),
          "sub-district": this.shippingAddress2.sub_district.replace(/,/g, ""),
          address: this.shippingAddress.replace(/,/g, ""),
          tel: this.customerPhone,
        };
      }

      var shipping = this.shippingType ? this.shippingType.type : null;
      if (shipping && shipping.toLowerCase().indexOf("other") != -1) {
        shipping = this.shippinglist[shipping][4];
      }

      let data = {
        amount: this.totalPrice
          .toFixed(2)
          .toString()
          .replace(".", ""),
        pageid: this.pageid,
        userid: this.userid,
        app: this.app,
        name: this.customerName,
        address: combine_address,
        phone: this.customerPhone,
        payment: payment,
        nameaddress:
          this.customerName.replace(/,/g, "") +
          " , " +
          combine_address +
          " , " +
          this.customerPhone.replace(/,/g, ""),
        shippingtype: shipping,
        note: note,
        remark:
          this.pageProfile.type == "monobo"
            ? this.remark + ";;" + this.bankname
            : this.remark,
        shippingcharge: shippingCharge
          .toFixed(2)
          .toString()
          .replace(".", ""),
        total: total
          .toFixed(2)
          .toString()
          .replace(".", ""),
        shipping_address: shipping_address,
      };

      if (this.voucher) {
        data.promocode = this.voucher.promocode;
      }
      if (this.sessiontoken != null || this.sessiontoken != "") {
        data.sessiontoken = this.sessiontoken;
      }

      if (this.isBearhouse) {
        data.shippingtype = "other_charge";
        data.shippingcharge = this.bearhouseshippingprice
          .toFixed(2)
          .toString()
          .replace(".", "");
        data.total = (this.total + this.bearhouseshippingprice)
          .toFixed(2)
          .toString()
          .replace(".", "");
      }
      // central
      if (this.isCDS) {
        data.shippingtype = "other_charge";
        data.shippingcharge = this.cdsshippingprice
          .toFixed(2)
          .toString()
          .replace(".", "");
        data.total = (this.total + this.cdsshippingprice)
          .toFixed(2)
          .toString()
          .replace(".", "");
      }

      if (this.isSmoothE) {
        var smootheShippingPrice = this.total >= 500 ? 0 : this.cdsshippingprice;
        data.shippingcharge = smootheShippingPrice
          .toFixed(2)
          .toString()
          .replace(".", "");
        data.total = (this.total + smootheShippingPrice)
          .toFixed(2)
          .toString()
          .replace(".", "");
      }


      if (this.pageProfile.type == 'nvbb') {
        if (!this.hasShippingNow) {
          data.remark = (data.remark ? data.remark : '') + " (จัดส่งทันที)";
        }
      }


      return data;
    },

    getUserCart: function () {
      let vm = this;
      return new Promise((resolve, reject) => {
        vm.$store.dispatch("deleteAllItemsInCart");
        axios
          .get(
            config.getConfig("serverUrl") + "usercart?pageid=" + vm.pageid + "&userid=" + vm.userid
          )
          .then(async (response) => {
            // JSON responses are automatically parsed.
            response = response.data;

            if (response.responsecode == 200) {
              vm.allowtransfer = response.allowtransfer == true || response.allowtransfer == "true";
              vm.banktransferinfo = response.banktransferinfo;
              vm.banktransferinfo_photo = response.banktransferinfo_photo;
              // vm.$store.dispatch('setCart',response.cartarray)
              if (response.cartarray) {
                if (response.cartarray.length == 0) {
                  vm.isEmptyShoppingCart = true;
                } else {
                  vm.isEmptyShoppingCart = false;
                }
                var product_id_list = [];
                var products = [];

                products = response.cartarray.map(function (val) {
                  product_id_list.push(val.productid);
                  var option = null;
                  var productIndex = vm.allproducts.findIndex((el) => {
                    return el.id == val.productid;
                  });

                  if (val.option) vm.hasOtherProduct = val.option.indexOf("Other-") != -1;

                  if (productIndex != -1) {
                    var stock = vm.allproducts[productIndex].productstock;

                    option = stock.find(function (el) {
                      if (["khaiwhan", "gaigao"].includes(vm.pageProfile.type)) {
                        if (val.option != "Normal") {
                          return el[1] == val.option.split(" - ")[0];
                        } else {
                          return el[1] == "Normal";
                        }
                      } else {
                        return el[1] == val.option;
                      }
                    });
                  }
                  return {
                    ...val,
                    id: val.productid,
                    price: parseFloat(val.price),
                    discountprice: parseFloat(val.discountprice),
                    optionDetail: option,
                  };
                });

                vm.additionalproduct_charge = parseFloat(response.additionalproduct_charge);
                vm.ems_charge = parseFloat(response.ems_charge);
                vm.normal_charge = parseFloat(response.normal_charge);
                vm.kerry_charge = parseFloat(response.kerry_charge);
                vm.total = parseFloat(response.total);
                vm.totalincludediscount = parseFloat(response.totalincludediscount);
                vm.discount = parseFloat(response.discount);

                vm.shippinglist = response.shippinglist;
                if (vm.pageProfile.type == "nvbb") {
                  vm.nvbbshippinglist = _.cloneDeep(response.shippinglist);
                  delete vm.nvbbshippinglist["other_charge"];
                }

                if (response.promocode) {
                  vm.voucherCode = response.promocode;
                }

                if (products.length > 0) {
                  // for (let index = 0; index < products.length; index++) {
                  //   await vm.$store.dispatch("addToCart", products[index]);
                  // }
                  vm.$store.commit("SET_ALL_CART", products);

                  let url =
                    config.getConfig("serverUrl") +
                    "productbundle?productid=" +
                    product_id_list.join(",");
                  axios.get(url).then((response) => {
                    response = response.data;
                    if (response.responsecode == 200 && response.productbundlelist.length > 0) {
                      vm.$store.commit("UPDATE_BUNDLE_CART", response.productbundlelist);
                    }
                  });
                }
              }
              resolve();
            } else {
              // console.log(response);
              reject();
            }
          });
      });
    },
    goToShop: function () {
      let vm = this;
      let url = "/ecommerce/" + vm.pagename;
      if (vm.userid && vm.userid != null && vm.userid != "") {
        url += "?userid=" + vm.userid;
        if (vm.sessiontoken && vm.sessiontoken != null && vm.sessiontoken != "") {
          url += "&sessiontoken=" + vm.sessiontoken;
        }
      }
      vm.$router.push({ path: url });
    },
    getProducts: function () {
      let vm = this;
      return new Promise((resolve, reject) => {
        var data = {
          pageid: vm.pageid,
        };
        if (
          vm.pageProfile &&
          vm.pageProfile.useketshop == true &&
          vm.pageProfile.ketshop_api_key &&
          vm.pageProfile.ketshop_api_secret
        ) {
          data["ketshop_api_key"] = vm.pageProfile.ketshop_api_key;
          data["ketshop_api_secret"] = vm.pageProfile.ketshop_api_secret;
        }
        axios
          .get(config.getConfig("serverUrl") + "products", {
            params: data,
          })
          .then((response) => {
            // JSON responses are automatically parsed.
            response = response.data;
            if (response.responsecode == 200) {
              vm.products = {};
              var products = response.productlist.filter((el) => {
                // console.log(el.status);
                return el.status == true;
              });

              // var result = vm.formatProducts(products, vm.categories);
              var allresult = vm.formatProducts(products);
              vm.products = allresult.product_by_index;

              vm.allproducts = allresult.products;

              resolve();
            } else {
              // console.log(response);
              reject();
            }
          });
      });
    },

    renderPaypalBtn: function () {
      var vm = this;
      var SERVER = config.getConfig("serverUrl");
      var paypalbtn = document.getElementById("paypal-button");

      if (paypalbtn) {
        paypalbtn.remove();
      }
      const paypal_newbtn = document.createElement("div");
      paypal_newbtn.id = "paypal-button";
      this.$refs["paypal-button-container"].appendChild(paypal_newbtn);
      this.$nextTick(() => {
        var lang = "";
        if (vm.currentLang == "th") {
          lang = "th_TH";
        } else if (vm.currentLang == "la") {
          lang = "en_LA";
        } else {
          lang = "en_US";
        }
        vm.$loadScript("https://www.paypalobjects.com/api/checkout.js")
          .then(() => {
            // Script is loaded, do something
            // eslint-disable-next-line no-undef
            paypal.Button.render(
              {
                locale: lang,
                env: vm.environment,

                validate: function (actions) {
                  // console.log("validate");
                  vm.paypal_actions = actions;
                  vm.paypal_actions.disable();
                  // console.log("validate", actions);
                  vm.$validator.validate().then((result) => {
                    if (!result) {
                      // do stuff if not valid.
                      vm.paypal_actions.disable();
                      vm.goToErrorInput();
                      return false;
                    }
                    vm.paypal_actions.enable();
                  });
                },
                onClick: function (data, actions) {
                  // console.log("click", actions);
                  if (vm.paypal_actions) {
                    // vm.paypal_actions.disable();
                    // console.log(vm.paypal_actions);
                    vm.$validator.validate().then((result) => {
                      if (!result) {
                        vm.goToErrorInput();
                        // do stuff if not valid.
                        vm.paypal_actions.disable();
                        // console.log("click error");
                        return false;
                      }
                      // console.log("click pass");
                      vm.paypal_actions.enable();
                    });
                  }
                },
                payment: function (data, actions) {
                  // console.log("payment", actions);
                  var request = {
                    amount: vm.totalPrice.toFixed(2).toString(),
                    pageid: vm.pageid,
                    userid: vm.userid,
                    paypal_merchantid: vm.pageProfile.paypal_merchantid,
                  };
                  if (this.$route.query.from) {
                    request.from = this.$route.query.from;
                  } else {
                    try {
                      var device = this.$liff.getOS();
                      var version = this.$liff.getVersion();
                      this.$liff.ready.then(() => {
                        if (
                          this.userid.indexOf("__") != -1 &&
                          device &&
                          version &&
                          !this.$liff.isInClient()
                        ) {
                          data.from = "livechat";
                        }
                      });
                    } catch (error) {
                      // eslint-disable-next-line
                      console.log(error);
                    }
                  }
                  return actions.request
                    .post(SERVER + "merchant-api/create-payment/", request)
                    .then(function (res) {
                      return res.id;
                    });
                },
                onAuthorize: function (data, actions) {
                  // console.log("onAuthorize", actions);
                  // console.log("ON AUTHORIZED");
                  // console.log(data);
                  // 2. Make a request to your server

                  var request = vm.formatOrderRequest();
                  // console.log(request);

                  request.paymentID = data.paymentID;
                  request.payerID = data.payerID;
                  request.paypal_merchantid = vm.pageProfile.paypal_merchantid;
                  if (vm.$store.state.cds.includes(vm.pageid))
                    request.remark = "หมายเลขเดอะวัน:" + vm.remark;
                  if (vm.$route.query.from) {
                    request.from = vm.$route.query.from;
                  } else {
                    try {
                      var device = vm.$liff.getOS();
                      var version = vm.$liff.getVersion();
                      vm.$liff.ready.then(() => {
                        if (
                          vm.userid.indexOf("__") != -1 &&
                          device &&
                          version &&
                          !vm.$liff.isInClient()
                        ) {
                          data.from = "livechat";
                        }
                      });
                    } catch (error) {
                      // eslint-disable-next-line
                      console.log(error);
                    }
                  }

                  return actions.request
                    .post(SERVER + "merchant-api/execute-payment/", request)
                    .then(function () {
                      vm.isCompleted = true;
                      vm.$store.dispatch("deleteAllItemsInCart");
                      // eslint-disable-next-line
                      if (vm.$liff.isInClient()) {
                        // eslint-disable-next-line no-undef
                        vm.$liff.closeWindow();
                      } else if (vm.$route.query.app == "facebook") {
                        // eslint-disable-next-line no-undef
                        MessengerExtensions.requestCloseBrowser(
                          function success() { },
                          function error() {
                            window.close();
                          }
                        );
                      } else {
                        let url = "/ecommerce/" + vm.pagename;
                        if (vm.userid && vm.userid != null && vm.userid != "") {
                          url += "?userid=" + vm.userid;
                        }
                        vm.$router.push({ path: url });
                      }
                    });
                },
              },
              "#paypal-button"
            );
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log(error);
            // Failed to fetch script
          });
      });
    },
  },
};
